import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, DefaultDataServiceConfig, HttpUrlGenerator, QueryParams } from '@ngrx/data';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from 'src/app/shared/_models/user.model';

@Injectable({
  providedIn: 'root'
})

export class UserDataService extends DefaultDataService<User> {
  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, config: DefaultDataServiceConfig) {
    super('users', http, httpUrlGenerator, config);
  }

  // getWithQuery(queryParams: QueryParams | string): Observable<User[]> {
  //   return super.getWithQuery(queryParams).pipe(map(res => {
  //     const data = res['content'];
  //     return data as any;
  //   }));
  // }
}
